import { Box, Inspector, List } from '@bynder/design-system';
import { useActiveWidget } from '../../../../queries/guides';
import { TeaEditorControls } from '@bynder/tea-pot-lib';
import { WidgetSettingsHeader } from '../../Styles';
import { WIDGET_TYPE } from '../../../../types/widgets';
import { Translate } from '@bynder/localization';

export const TeaWidgetSettings = () => {
  const widget = useActiveWidget();

  return <TeaEditorControls id={widget.id}>
    <WidgetSettingsHeader widgetType={WIDGET_TYPE.TEA} />
    <Inspector.Divider />
    <Box paddingBottom="2" paddingTop="4">
      <List.Item>
        <Translate id="WIDGETS_INSPECTOR.TEA_ALIGNMENT_TITLE" />
      </List.Item>
      <TeaEditorControls.Alignment></TeaEditorControls.Alignment>
    </Box>
    <Inspector.Divider />
    <Box paddingBottom="2" paddingTop="4">
      <List.Item>
        <Translate id="WIDGETS_INSPECTOR.TEA_SCRIPT_TITLE" />
      </List.Item>
      <TeaEditorControls.Script></TeaEditorControls.Script>
    </Box>
    <Inspector.Divider />
    <Box paddingBottom="2" paddingTop="4">
      <List.Item>
        <Translate id="WIDGETS_INSPECTOR.TEA_INSERT_TITLE" />
      </List.Item>
      <TeaEditorControls.Insert></TeaEditorControls.Insert>
    </Box>
  </TeaEditorControls>
};
